import DeviceManager from '../utils/device-manager';
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class NewsSlider {
    constructor($el) {
        this.$el = $el;
        this.hasSlides = this.$el.find('.article').length > 0;

        this.options = {
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            cellSelector: '.article',
            cellAlign: 'left',
        };

        if(this.$el.length && this.hasSlides) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.article');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 3) {
            this._createSlider();
        }
    }

    _destroy() {
        if(this.slider) {
            this.$el.flickity('destroy');
            this.slider = null;
        }
    }

    _createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}
export default NewsSlider;
